import Button from '@carvana/ds-button';

export default function SubmitButton() {
  return (
    <Button
      size="lg"
      variant="primary"
      utility
      type="submit"
      data-analytics-id={null}
      data-testid="zipcode-form-submit"
    >
      Update
    </Button>
  );
}
